export default function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}) {
  return (
    <div
      role="status"
      className={`flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-surfaceAlt/40 p-8 text-center ${className}`}
    >
      {icon ? <div className="mb-3 text-4xl text-primary">{icon}</div> : null}
      {title ? <h3 className="text-base font-semibold text-text">{title}</h3> : null}
      {description ? (
        <p className="mt-1 max-w-xs text-sm text-secondText">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
